import {
  CsvExportDefinition,
  formatInverseBoolean,
  formatUnixSecondsDateTime
} from "../../common/csvExport";

interface DeviceExportRecord {
  id: string | number;
  deviceShortId?: string;
  alias?: string;
  deviceType?: { displayName?: string };
  createdAt?: number;
  disabled?: boolean;
}

const dateOptions: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "short",
  day: "numeric"
};

export const deviceExportDefinition: CsvExportDefinition<DeviceExportRecord> = {
  resource: "Device",
  filenameStem: "patient-devices",
  id: { header: "deviceID", source: "id" },
  columns: [
    {
      key: "deviceShortId",
      label: "Device ID",
      source: "deviceShortId",
      getValue: (r) => r.deviceShortId
    },
    {
      key: "alias",
      label: "Device Alias",
      source: "alias",
      getValue: (r) => r.alias
    },
    {
      key: "deviceType",
      label: "Device Type",
      source: "deviceType.displayName",
      getValue: (r) => r.deviceType?.displayName
    },
    {
      key: "createdAt",
      label: "Date Created",
      source: "createdAt",
      getValue: (r) => formatUnixSecondsDateTime(r.createdAt, dateOptions)
    },
    {
      key: "enabled",
      label: "Enabled",
      source: "disabled",
      getValue: (r) => formatInverseBoolean(r.disabled)
    }
  ]
};
